import Common from "./common.js";
import "../../scss/v5/news.scss";

Common.initPage();
